import { Injectable } from "@angular/core";
import { Effect, ofType, Actions } from "@ngrx/effects";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { IframePayload } from "@edp-pages/iframe/iframe.model";
import { EIframeActions, SetIframe } from "@edp-store/actions/iframe.actions";

@Injectable()
export class IframeEffects {

    @Effect()
    resetIframe$ = this.actions$.pipe(
        ofType(EIframeActions.ResetIframe),
        switchMap(() => {
            const params = {
                url: "private/contract/start"
            } as IframePayload;

            return of(
                new SetIframe(params, true, true)
            );
        })
    );

    constructor(
        private actions$: Actions,
    ) { }
}
